import { ReactNode } from 'react';
import { Check } from '@mui/icons-material';
import { Box, ButtonBase, CircularProgress, Divider, Grow, Typography } from '@mui/material';

type Props = {
  title: string;
  description: string;
  onClick: () => void;
  selected: boolean;
  actionArea?: ReactNode;
  loading?: boolean;
};

export const SelectCard = ({ title, description, onClick, selected, loading, actionArea }: Props) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={(theme) => ({
        bgcolor: 'background.paper',
        p: 2,
        maxWidth: 375,
        borderRadius: 1,
        outlineWidth: selected ? 2 : 1,
        outlineStyle: 'solid',
        outlineColor: selected ? theme.palette.primary.main : theme.palette.action.focus,
        '&:hover, &:focus': {
          outlineColor: theme.palette.primary.light,
        },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <Grow in={selected || loading}>
        <Box
          sx={{
            position: 'absolute',
            top: -35,
            left: '20%',
            right: '20%',
            borderRadius: 3,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            overflow: 'hidden',
            zIndex: -1,
          }}
        >
          <Box
            sx={(theme) => ({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
              backgroundColor: theme.palette.primary.main,
              color: 'white',
              pb: 1,
              pt: 0.5,
            })}
          >
            {loading ? <CircularProgress color={'inherit'} size={22} /> : <Check />}
          </Box>
        </Box>
      </Grow>

      <Box display={'flex'} flex={'1 1 0'} flexDirection={'column'} justifyContent={'flex-start'}>
        <Typography gutterBottom variant={'h2'} component={'h3'}>
          {title}
        </Typography>
        <Divider />
        <Typography textAlign={'left'} color={'text.secondary'} mt={2}>
          {description}
        </Typography>
        <Box display={'flex'} flex={'1 1 0'}>
          {actionArea}
        </Box>
      </Box>
    </ButtonBase>
  );
};
